import handlebars from "handlebars";
import keyProvisionsInternationalTemplate from "../templates/keyProvisionsInternationalTemplate";
import { CommentKey } from "../../../constant";

export const compileKeyProvisionInternationalTemplate = (commentData: any[], keyProvisionData: any): string => {


  console.log("international template compiler", keyProvisionData);
  

  const compileKeyProvisionTemplate = handlebars.compile(keyProvisionsInternationalTemplate);
  handlebars.registerHelper('add', function (value: number, addition: number) {
    return value + addition;
  });
  
  const Comment: any = commentData || [];
  const KeyProvisionComment = {
    mangementComment_date:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.MANAGEMENTAGREEMENT_DATE.toLowerCase()
      )?.commentText || "",
    mangementComment_fee:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.MANAGEMENTAGREEMENT_FEE.toLowerCase()
      )?.commentText || "",
    mangementComment_otherFee:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.MANAGEMENTAGREEMENT_OTHERFEE.toLowerCase()
      )?.commentText || "",
    leasebroker_name:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.LEASEBROKER_NAME.toLowerCase()
      )?.commentText || "",
    leasebroker_fee:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.LEASEBROKER_FEE.toLowerCase()
      )?.commentText || "",
    leasebroker_otherfee:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.LEASEBROKER_OTHERFEE.toLowerCase()
      )?.commentText || "",
    jvagreement_KeyDecision:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.JVAGREEMENT_KEYDECISION.toLowerCase()
      )?.commentText || "",
    jvagreement_liquidProvision:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.JVAGREEMENT_LIQUIDITYPROVISION.toLowerCase()
      )?.commentText || "",
    jvagreement_fee:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.JVAGREEMENT_FEE.toLowerCase()
      )?.commentText || "",
    jvagreement_Keyprovision:
      Comment?.find(
        (x) =>
          x.commentKey?.toLowerCase() ===
          CommentKey.JVAGREEMENT_KEYPROVISION.toLowerCase()
      )?.commentText || "",
  };

  const data = {
    KeyProvisionComment,
    keyProvisionData
  };
  
  return compileKeyProvisionTemplate(data);
};